import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
import { SettingStore } from "./store";
let store = null;
export const StoreContext = createContext(null);
export function useStore() {
    const context = useContext(StoreContext);
    if (!context) {
        throw new Error("useStore must be used within StoreProvider");
    }
    return context;
}
export function initializeStore(initialData = null) {
    const _store = store !== null && store !== void 0 ? store : new SettingStore();
    if (initialData) {
        _store.hydrate(initialData);
    }
    // if (typeof window === "undefined") return _store;
    if (!store)
        store = _store;
    return _store;
}
export function SettingStoreProvider({ children, initialState, }) {
    const settingStore = initializeStore(initialState);
    return (_jsx(StoreContext.Provider, { value: settingStore, children: children }));
}
